import { Text } from '@costar/theme-ui';
import React from 'react';
import defaultGetOptionLabel from '../helpers/default-get-option-label.esm.js';
import defaultIsSelectAllOption from '../helpers/default-is-select-all-option.esm.js';

function defaultRenderMultiSelectText(options) {
  var isSelectAllOption = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultIsSelectAllOption;
  var getTagLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultGetOptionLabel;
  return function MultiSelectText(value) {
    var allOptions = options.filter(function (i) {
      return !isSelectAllOption(i);
    });
    var nonOptions = (value === null || value === void 0 ? void 0 : value.filter(function (i) {
      return isSelectAllOption(i);
    })) || [];
    var selectOptions = (value === null || value === void 0 ? void 0 : value.filter(function (i) {
      return !isSelectAllOption(i);
    })) || [];
    var selections = nonOptions.length > 1 ? allOptions : selectOptions.length > 0 ? selectOptions : [];
    return /*#__PURE__*/React.createElement(React.Fragment, null, selections.map(function (option, index) {
      return /*#__PURE__*/React.createElement(Text, {
        key: "autocomplete-tag-".concat(index),
        ellipsis: true
      },
      // @ts-ignore -- FIXME(don): T is not restrictive enough
      getTagLabel(option));
    }));
  };
}

export default defaultRenderMultiSelectText;
//# sourceMappingURL=default-render-multi-select-text.esm.js.map
